/* eslint no-eval: off */
import {defineStore} from 'pinia';
import axios from 'axios';
import {notify} from '../assets/js/utils.js';
import {json_parse, stringify} from '../assets/js/json.js';
// import qs from 'qs';

async function asleep(ms) {
    await new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, ms);
    });
}

const UserStore = defineStore('userstore', {
    state: () => ({
        data: null,
        token: null,
    }),
    getters: {
        user(state) {
            return state.data;
        },
        is_admin(state) {
            return state.has_role('admin');
        },
        is_logged(state) {
            return !!state.data;
        },
    },
    actions: {
        has_role(rolename) {
            console.log('checking role', rolename, this.data);
            return this.data?.roles?.some(x => x.name === rolename) || false;
        },

        async try_load(url, params) {
            try {
                const res = await axios.get(url, {
                    params,
                    transformResponse(data) {
                        return json_parse(data);
                    },
                });
                // console.debug('loaded content type', res.headers['content-type']);
                // console.debug('loaded:', res);
                (res.messages || []).forEach(async msg => {
                    // 延迟测量避免notify显示重叠，可能是notify显示的计算的一种缺陷
                    await asleep(1);
                    // 显示警告信息
                    notify('warning', msg, 0);
                });
                return res;
            } catch (exc) {
                if (exc.response?.status !== 401 && exc.response?.status !== 422) {
                    console.error(exc);
                }
            }
        },

        async login(username, password) {
            const url = '/user/api/login';
            try {
                const res = await axios.post(url, {username, password});
                this.data = res?.data?.data;
                this.token = res?.data?.token;
                console.log(this.data, this.token);
                // 如果登录成功则在本地存储用户名称和token
                if (this.token) {
                    localStorage.setItem('auth_token', this.token);
                }
                return null;
            } catch (exc) {
                if (exc.response?.status !== 401) {
                    console.error(exc);
                }
                if (exc.code === 'ERR_NETWORK') {
                    return `连接服务器失败！${exc.message}`;
                }
                const msg = exc.response?.data?.message ?? exc.response?.statusText ?? exc.message;
                return `登录失败！${msg}`;
            }
        },
        async logout() {
            const url = 'user/api/logout';
            await this.try_load(url);
            this.data = null;
            this.token = null;
            localStorage.removeItem('auth_token');
        },

        async load() {
            if (this.data) return this.data;
            // 从localStorage恢复token
            const storedToken = localStorage.getItem('auth_token');
            if (storedToken) {
                this.token = storedToken;
            }
            try {
                const url = 'user/api/info';
                const res = await this.try_load(url);
                this.data = res?.data?.data;
                return this.data;
            } catch (exc) {
                // 如果API调用失败，清除无效token
                this.token = null;
                this.data = null;
                localStorage.removeItem('auth_token');
                return null;
            }
        },

        async modify(_uid, tags) {
            const url = `user/api/`;
            const res = await axios({
                method: 'post',
                url,
                data: stringify(tags),
                headers: {
                    'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
                },
            });
            console.debug('response:', res);
            return res;
        },

        async switch(username) {
            try {
                const url = '/user/api/switch';
                const res = await axios.post(url, {username});
                this.data = res.data.data;
            } catch (exc) {
                if (exc.response?.status !== 401) {
                    console.error(exc);
                }
                if (exc.code === 'ERR_NETWORK') {
                    return `连接服务器失败！${exc.message}`;
                }
                const msg = exc.response?.data?.message ?? exc.response?.statusText ?? exc.message;
                return `登录失败！${msg}`;
            }
        },

        // 处理认证失败的情况
        handleAuthError() {
            this.data = null;
            this.token = null;
            localStorage.removeItem('auth_token');
            // 延迟跳转，避免在路由守卫中重复跳转
            setTimeout(() => {
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }, 100);
        },
    },
});

export default UserStore;
export {UserStore};
